import { User } from './user.model';

export interface TaskTemplateAssignee {
  id: number;
  userId: string;
  user: User;
}

export class TaskTemplate {
  applicationTypeId: string;
  autoCompleteType?: string | null;
  autoCompleteUDFId?: string | null;
  autoCompleteFileTypeId?: string | null;
  autoCompleteDocumentTemplateId?: string | null;
  autoCompleteBusinessRoleId?: number | null;
  autoCompletePaymentTypeId?: number | null;
  autoCompleteSupplementalFormApplicationStatusId?: string | null;
  autoCompleteSupplementalFormApplicationTypeId?: string | null;
  autoCompleteSupplementalFormToStateId?: string | null;
  blocksStatusChange?: boolean;
  description: string;
  displayName: string;
  durationInDays?: number;
  dueDate?: Date;
  id?: number;
  notes: string;
  priority: string;
  status: string;
  taskAssignments?: TaskTemplateAssignee[];
}
